import React, { useEffect, useState } from "react";
import api from "../lib/api";

export const HELD_CHANGED = "datebid:held-payments-changed";
export const notifyHeldChanged = () => window.dispatchEvent(new Event(HELD_CHANGED));

// Count of payments currently held for review (server-derived). Hidden while loading, at zero, or on any error.
export const HeldPaymentsBadge = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/admin/payments/held/count")
      .then((r) => { if (alive) setCount(Number.isInteger(r?.data?.count) ? r.data.count : null); })
      .catch(() => { if (alive) setCount(null); });
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener(HELD_CHANGED, load);
    return () => { alive = false; clearInterval(timer); window.removeEventListener(HELD_CHANGED, load); };
  }, []);
  if (!count) return null;
  const label = `${count} payment${count === 1 ? "" : "s"} held for review`;
  return (
    <span data-testid="admin-reconciliation-held-badge" role="status" aria-label={label} title={label}
      className="ml-auto inline-flex min-w-[22px] h-[22px] items-center justify-center rounded-full bg-[#D92D3F] px-1.5 text-[11px] font-bold leading-none text-white tabular-nums ring-2 ring-[#141113]">
      {count > 99 ? "99+" : count}
    </span>
  );
};

export default HeldPaymentsBadge;
